import { useSingleListSearchPage } from './useSingleListSearchPage/useSingleListSearchPage';

/**
 * @deprecated Use `useSingleListSearchPage` instead.
 */
export const useSearchPage = useSingleListSearchPage;
